import React, { useEffect } from 'react';
import Dragger from 'draggerjs'
import { SectionWithCode } from 'Templates';
import * as code from '../StringCodes'; 

export const Autoscroll = () => {
    
    useEffect(() => {
        const dragger = new Dragger('#drag-autoscroll', {
            draggable: '.draggable-box',
            autoscroll: true
        })
        dragger.on('dragstart', (e) => { 
            const target = e.target
            if(e.isDraggableElement) {
                // prevent mobile from scrolling
                // when dragging draggable element
                e.preventDefault()
                target.classList.add('grabbed')
                if(target.classList.contains('center')) {
                    target.classList.remove('center')
                }
            }
        })
        dragger.on('dragend', (e) => {
            if(e.isDraggableElement) {  
                e.target.classList.remove('grabbed') 
            }
        })
        return () => dragger.destroy()
    }, [])

    return (
        <>  
            <SectionWithCode
                readonly
                title='Autoscroll'
                context={<>you can easily apply autoscroll in the draggerjs just add <b>autoscroll: true</b> in the options.</>}
                code={code.Autoscroll}
            >
                <div className="drag-container drag-long-ground" id="drag-autoscroll"  data-example>  
                    <div className="drag-around n-border-color">
                        <div className="draggable-box center n-flat">
                            <h1>Drag Me</h1>
                        </div> 
                    </div>
                </div>
            </SectionWithCode>
        </>
    );
}